import React from 'react'
import { FaFacebook } from 'react-icons/fa';
export const HeroSection = (props) => {
    return (
        <div className={`profileContent`}>
            <h1 className='hero-title text-white'>
                {props?.heroData?.displayName}
            </h1>
            <h3 className="hero-position text-white">{props?.heroData?.jobTitle}</h3>
            <p className="hero-paragraph text-white">
                {props?.heroData?.homePageData?.tempData?.summary}
            </p>
            {
                props?.heroData?.socialNeworks && props?.heroData.socialNeworks?.length > 0 &&
                    <ul className="social-icons-cover">
                        {
                            props?.heroData?.socialNeworks?.map((val, index) => {
                                return (
                                    <li key={index} className='social-linkedin'>
                                        <a href={val.url} target="_blank" rel="noreferrer">
                                            <FaFacebook/>
                                        </a>
                                    </li>
                                )
                            })
                        }
                    </ul>
            }

        </div>
    )
}